import { useEffect, useState } from "react";
import { ArticleDataObject } from "@app/types/Cue";
import BasicCard from "@components/ArticleCard/BasicCard";
import { CardVariations } from "@components/ArticleCard/types";
import Column from "@components/Grid/Column";
import Row from "@components/Grid/Row";
import { getArticleBlurb, getKickerFromArticleDataObject } from "@util/helpers";

export type WealthTopStoriesProps = {
  data: ArticleDataObject[];
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function WealthTopStories({
  data = [],
}: WealthTopStoriesProps): React.ReactElement {
  const [topStory, setTopStory] = useState<ArticleDataObject>();
  const [subStories, setSubStories] = useState<ArticleDataObject[]>([]);

  const variant = {
    image: {
      width: "w-100",
    },
    content: {
      extraClass:
        "text-white left-0 bottom-0 right-0 md:right-1/2 md:top-0 bg-gradient-to-b md:bg-gradient-to-l justify-center flex flex-col absolute order-2 from-transparent to-black p-3",
    },
    title: {
      size: "text-lg md:text-6xl",
    },
  } as CardVariations;

  useEffect(() => {
    setTopStory(data?.[0]);
    setSubStories(data?.slice(1, 9));
  }, [data]);

  return (
    <>
      <Row data-testid="wealth-top-stories-component">
        {topStory ? (
          <Column rootClassName="pb-6 w-full" key={1}>
            <BasicCard
              id={topStory.id}
              kicker={getKickerFromArticleDataObject(topStory)}
              title={topStory.title}
              media={topStory.media}
              paywall={topStory.paywall?.contentAccess === "1"}
              blurb={getArticleBlurb(topStory)}
              variations={variant}
              slug={topStory.slug}
            />
          </Column>
        ) : (
          <></>
        )}
        <>
          {subStories.length > 1 ? (
            subStories.map((article) => {
              return (
                <Column
                  rootClassName="pb-6 w-full md:w-6/12 lg:w-3/12"
                  key={article.id}
                >
                  <BasicCard
                    id={article.id}
                    title={article.title}
                    media={article.media}
                    paywall={article.paywall?.contentAccess === "1"}
                    created={article.created}
                    slug={article.slug}
                  />
                </Column>
              );
            })
          ) : (
            <></>
          )}
        </>
      </Row>
    </>
  );
}
